import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ErrorMessage } from "formik";

type Props = {
  name: string;
};

const FormErrorMessage = ({ name }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.error}>
      <ErrorMessage name={name} />
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  error: {
    fontSize: 12,
    color: theme.palette.error.main,
    textAlign: "left",
  },
}));

export { FormErrorMessage };
